import { ArrowUp } from "lucide-react";
import { toast } from "sonner";
import { SITE, scrollToId } from "@/config/site";

const Footer = () => {
  const legalToast = (doc) => () =>
    toast.info(`The ${doc} will be published here soon — thank you for your patience.`);

  return (
    <footer data-testid="footer-section" className="densa-grain bg-brand-deep text-emerald-50/80">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.2fr_1fr_1.2fr]">
          <div>
            <img
              src={SITE.assets.logoWhite}
              alt="DENSA — Dental Excellence & Networked Smart Administration"
              className="h-9 w-auto"
              data-testid="footer-logo"
            />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-emerald-50/60">
              The all-in-one dental clinic management app — patients, appointments, finances, inventory, analytics and
              DIVA, your AI assistant, in one connected platform. Built by dentists, for real dental practice.
            </p>
            <p className="mt-5 max-w-sm text-[13px] leading-relaxed text-emerald-50/50" data-testid="footer-legal-disclosure">
              DENSA is a software brand owned and operated by{" "}
              <span className="font-semibold text-emerald-50/75">AGNI HEALTHTECH SOLUTION</span>, a software and
              IT-enabled services business based in India.
            </p>
          </div>

          <nav aria-label="Footer">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-emerald-200/60">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {SITE.nav.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId(item.href);
                    }}
                    className="inline-flex min-h-[32px] items-center text-sm text-emerald-50/70 transition-colors hover:text-white"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.25em] text-emerald-200/60">Legal</p>
            <div className="mt-3 flex flex-col items-start gap-2.5">
              <button
                type="button"
                data-testid="footer-privacy-link"
                onClick={legalToast("Privacy Policy")}
                className="min-h-[32px] text-sm text-emerald-50/70 transition-colors hover:text-white"
              >
                Privacy Policy
              </button>
              <button
                type="button"
                data-testid="footer-terms-link"
                onClick={legalToast("Terms of Service")}
                className="min-h-[32px] text-sm text-emerald-50/70 transition-colors hover:text-white"
              >
                Terms of Service
              </button>
            </div>
          </nav>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-emerald-200/60">Company &amp; Contact</p>
            <div className="mt-4 space-y-2 text-sm leading-relaxed text-emerald-50/70" data-testid="footer-company-info">
              <p className="font-semibold text-emerald-50/90">AGNI HEALTHTECH SOLUTION</p>
              <p>Software Development · SaaS · IT-enabled Services</p>
              <p>Trade Licence No: HMC/W18/343498/26</p>
              <p>47/1 Lakshman Das Lane, Howrah 711101, India</p>
              <p>
                <a href="tel:+918240619850" className="transition-colors hover:text-white">
                  +91 8240619850
                </a>
              </p>
              <p>
                <a href="mailto:support@densa.in" className="transition-colors hover:text-white">
                  support@densa.in
                </a>
                {" · "}
                <a href={`mailto:${SITE.email}`} className="transition-colors hover:text-white">
                  {SITE.email}
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row">
          <p className="text-xs text-emerald-50/50" data-testid="footer-copyright">
            © 2026 AGNI HEALTHTECH SOLUTION. All rights reserved.
          </p>
          <button
            type="button"
            data-testid="footer-back-to-top"
            onClick={() => scrollToId("#home")}
            aria-label="Back to top"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-emerald-50/70 transition-all duration-200 hover:-translate-y-0.5 hover:border-emerald-300/50 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300"
          >
            <ArrowUp className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
